export default __webpack_public_path__ + "static/media/Add_to_Apple_Wallet.0969b1ca.png";